
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#38393A","d":"M12 3a3 3 0 00-3 3c0 3 5 7-3 7a2 2 0 00-2 2v2h16v-2a2 2 0 00-2-2c-8 0-3-4-3-7 0-2-1.34-3-3-3M6 20a1 1 0 001 1h10a1 1 0 000-2H7a1 1 0 00-1 1z"}})])
          )
        }
      }
    